// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MultilingualString } from "./MultilingualString";
import {
  MultilingualStringFromJSON,
  MultilingualStringFromJSONTyped,
  MultilingualStringToJSON,
  MultilingualStringToJSONTyped,
} from "./MultilingualString";

/**
 *
 * @export
 * @interface Keywords
 */
export interface Keywords {
  /**
   *
   */
  title?: string | null;
  /**
   *
   */
  multilingualTitle?: MultilingualString | null;
  /**
   *
   */
  theme?: string;
  /**
   *
   */
  keywords?: Array<MultilingualString>;
  /**
   *
   */
  id?: string | null;
}

/**
 * Check if a given object implements the Keywords interface.
 */
export function instanceOfKeywords(value: object): value is Keywords {
  return true;
}

export function KeywordsFromJSON(json: any): Keywords {
  return KeywordsFromJSONTyped(json, false);
}

export function KeywordsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Keywords {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"] === undefined ? undefined : json["title"] === null ? null : json["title"],
    multilingualTitle:
      json["multilingualTitle"] === undefined
        ? undefined
        : json["multilingualTitle"] === null
        ? null
        : MultilingualStringFromJSON(json["multilingualTitle"]),
    theme: json["theme"] == null ? undefined : json["theme"],
    keywords:
      json["keywords"] == null
        ? undefined
        : (json["keywords"] as Array<any>).map(MultilingualStringFromJSON),
    id: json["id"] === undefined ? undefined : json["id"] === null ? null : json["id"],
  };
}

export function KeywordsToJSON(json: any): Keywords {
  return KeywordsToJSONTyped(json, false);
}

export function KeywordsToJSONTyped(
  value?: Keywords | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    multilingualTitle: MultilingualStringToJSON(value["multilingualTitle"]),
    theme: value["theme"],
    keywords:
      value["keywords"] == null
        ? undefined
        : (value["keywords"] as Array<any>).map(MultilingualStringToJSON),
    id: value["id"],
  };
}
